import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'user-last-login-renderer',
  template: `
    <span>
      {{ getLastLogin(rowData?.LastModified) }}
    </span>
  `,
  standalone: true,
})
export class UserLastLoginRenderer {
  @Input() rowData: any;

  constructor(private utilityService: UtilityService) {}

  getLastLogin(lastLogin: string): string {
    return this.utilityService.formatDateWithTime(lastLogin);
  }
}
